export default __webpack_public_path__ + "static/media/open-positions-mobile.6415f7f2.jpg";